// extracted by mini-css-extract-plugin
export default {"sectionWrapper":"Pp-z","outfitFeedbackSection":"Qp-z"};